import {
  cleanGiftsProductsParams,
  priceFilterCanBeSent
} from 'store/actions/gifts';
import { initialValues } from './formikProps';

export const mapStateToProps = (state) => {
  const reduceGiftParams = (acc, current) => {
    const paramValue = state.gifts.listOfGifts.params[current];

    if (!paramValue) return acc;

    acc[current] = paramValue;

    return acc;
  };

  const giftsParams = Object.keys(initialValues).reduce(reduceGiftParams, {});

  return {
    filters: state.gifts.filters,
    giftsParams,
    showRecommendations: state.gifts.showRecommendations
  };
};

export const mapDispatchToProps = {
  cleanGiftsProductsParams,
  priceFilterCanBeSent
};
